import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { PropertyBrowserTreeNode } from "api-client";
import { CSS } from "@dnd-kit/utilities";
import clsx from "clsx";
import { IconEyeOff, IconGripVertical } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { dynamicTableStore } from "features/DynamicTable/DynamicTableStore";
import { IconHexagon } from "@tabler/icons-react";
import { OBJECT_CATEGORIES_ICONS } from "features/DynamicTable/utils";
import { observer } from "mobx-react-lite";

const DraggbleItem = (props: {
  row: PropertyBrowserTreeNode;
  isGroupingColumn: boolean;
  selectedItemsLength: number;
}) => {
  const { i18n } = useTranslation();
  const isEng = i18n.language === "en";
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: props.row.id });

  const isInfoColumnAndOneItem =
    Number(props.selectedItemsLength) === 1 && !props.isGroupingColumn;

  const removeCurrentRow = (id: string) => {
    if (isInfoColumnAndOneItem) return;
    if (props.isGroupingColumn) {
      dynamicTableStore.filterStore.removeGroupingRule(id);
    } else {
      const updatedList = dynamicTableStore.visibleColumnProperties.filter(
        (item) => item.id !== id
      );
      dynamicTableStore.setVisibleColumnProperties(updatedList);
    }
    dynamicTableStore.filterStore.removeItemFromSortList(id);
  };

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  const categoryIcon = React.cloneElement(
    OBJECT_CATEGORIES_ICONS[props.row.group_name] || <IconHexagon size={20} />,
    { className: "min-w-[20px]", size: 20 }
  );

  return (
    <li
      ref={setNodeRef}
      style={style}
      className={clsx(
        "flex group items-center px-4 py-1.5 gap-2 justify-between text-gray-700",
        "hover:bg-indigo-50 hover:text-indigo-700 cursor-default h-9",
        {
          "opacity-70": isInfoColumnAndOneItem,
        }
      )}
    >
      <div className="flex items-center whitespace-nowrap overflow-hidden">
        <div className="mr-2 min-w-[24px] flex items-center justify-center">
          <div className="group-hover:hidden text-gray-400">{categoryIcon}</div>
          {props.selectedItemsLength > 1 && (
            <IconGripVertical
              {...attributes}
              {...listeners}
              size={24}
              className="hidden group-hover:block cursor-grab focus:outline-none -ml-1"
            />
          )}
        </div>
        <span className="truncate">
          {isEng ? props.row.name : props.row.name_de}
        </span>
      </div>
      <IconEyeOff
        className={clsx(
          "cursor-pointer ml-1 min-w-[20px] invisible shrink-0",
          isInfoColumnAndOneItem ? "hidden" : "group-hover:visible"
        )}
        size={20}
        onClick={() => removeCurrentRow(props.row.id)}
      />
    </li>
  );
};

export default observer(DraggbleItem);
